import { BaseLog, BaseLogArgs } from '../BaseLog';
import { LEVEL } from '../LEVEL';

export function PushJSLog({ message, data, level = LEVEL.WARN }: Partial<BaseLogArgs>) {
    return BaseLog({
        category: 'PUSH_JS',
        message,
        data,
        level
    });
}
